import React from 'react';
import Header from '../shared/Header';

import closeSvg from '../../assets/close.svg';
import './Modals.scss';

interface Props {
  children: React.ReactChild | React.ReactChild[] | React.ReactChildren | React.ReactChildren[];
  headerTitle?: string;
  onClose?: () => void;
}

const ModalWrapper = ({
  children, headerTitle, onClose,
}: Props): React.ReactElement => (
  <div className="modal">
    <div className="panel">
      <Header title={headerTitle} variant="h2" />

      {onClose && (
        <button
          type="button"
          onClick={onClose}
          className="button icon-button close"
        >
          <img src={closeSvg} alt="close" />
        </button>
      )}

      <div className="content">
        {children}
      </div>
    </div>
  </div>
);

export default ModalWrapper;
